import React from 'react';
import ReactDOM from 'react-dom';
import FaqQA from './FaqQA';
import SmoothCollapse from 'react-smooth-collapse';

class FaqCategory extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isOpened: false,
			friendlyId: this.props.category.categoryName.toLowerCase().replace(/\s+/g, '-')
		};
	}

	componentDidMount() {
		if (this.state.friendlyId === location.hash.replace('#', '')) {
			this.setState({
				isOpened: true
			});
		}
	}

	componentDidUpdate() {
		const hash = location.hash.replace('#', '');
		if (hash) {
			const node = ReactDOM.findDOMNode(this.refs[hash]);
			if (node) {
				node.scrollIntoView();
			}
		}
	}

	handleChange(checked) {
		this.setState({
			isOpened: checked
		});
		global.dataLayer.push({
			event: 'FAQ',
			eventCategory: 'Support',
			eventAction: 'FAQ Click',
			eventLabel: this.props.category.categoryName
		});
	}

	render() {
		const category = this.props.category;
		const isOpened = this.state.isOpened;
		const questions = category.items.map(
			(item,index) => <FaqQA qa={ item } key={ index } />
		);
		return (
			<div className="faq-category" ref={ this.state.friendlyId }>
				<h2 className="faq-category-title">
					<label htmlFor={ `checkbox-${this.state.friendlyId}` }>
						<input
							type="checkbox"
							id={ `checkbox-${this.state.friendlyId}` }
							checked={ isOpened }
							onChange={ ({ target: { checked } }) => this.handleChange(checked) }
						/>
						<span>{ category.categoryName }</span>
					</label>
				</h2>
				<SmoothCollapse expanded={ isOpened }>
					<ul className="faq-list">
						{ questions }
					</ul>
				</SmoothCollapse>
			</div>
		);
	}
}

export default FaqCategory;


// WEBPACK FOOTER //
// ./src/pages/support/faqs/FaqCategory.js